export const INFORMATION_ITEMS = [
  {
    text: 'Your Good Faith Estimate (GFE) shows expected costs; if billed $400+ over this amount, you have the right to dispute.',
    label: 'Learn more',
    href: 'mailto:support@myscribeai.com',
    icon: 'star-1-mono'
  },
  {
    text: 'Seeking clarity? Dr. ClearCare will explain your balance.',
    label: 'Learn more',
    href: 'mailto:support@myscribeai.com',
    icon: 'bulb-mono',
    hideIcon: true
  }
];

export const GOOD_FAITH_ESTIMATE_TEXT = `
This Good Faith Estimate (GFE) under the No Surprises Act (§300gg-136) reflects your current insurance status. Your cost may change if coverage or deductible updates, you opt out of insurance, or additional services are provided. Questions?
Contact our office.
`;
